import React from 'react';
import { ClientSideTable } from 'src/components/ClientSideTable';

interface Props {
  violationData: JobMetricViolation[] | undefined;
  loading: boolean;
}

export const ViolationsTable = ({ violationData, loading }: Props) => {
  const columns = [
    {
      header: 'Job Name',
      id: 'jobId',
      sortingField: 'job-name',
      cell: (item: JobMetricViolation) => (
        <div className="tooltip">
          {item.jobId}
          <div className="tooltip-text">{item.jobId}</div>
        </div>
      ),
    },
    {
      header: 'Job Type',
      id: 'jobType',
      sortingField: 'jobType',
      cell: (item: JobMetricViolation) => item.jobType,
    },
    {
      header: 'Feature',
      id: 'feature_name',
      sortingField: 'feature_name',
      cell: (item: JobMetricViolation) => item.feature_name,
    },
    {
      header: 'Constraint Check Type',
      id: 'constraint_check_type',
      sortingField: 'constraint_check_type',
      cell: (item: JobMetricViolation) => item.constraint_check_type,
    },
    {
      header: 'Description',
      id: 'description',
      sortingField: 'description',
      cell: (item: JobMetricViolation) => item.description,
    },
    {
      id: 'createdDate',
      header: 'Created Date',
      cell: (item: JobMetricViolation) => {
        const date = new Date(parseInt(item.createdDate) * 1000);
        return date.toUTCString();
      },
      sortingField: 'createdDate',
    },
  ];

  return (
    <ClientSideTable
      error={null}
      emptyText="No violation data."
      loading={loading}
      data={violationData || []}
      columnDefinitions={columns}
      title="Metrics Violations"
    />
  );
};
